import React, { useState, useEffect } from 'react';
import {
  useQueryParams,
  StringParam,
  withDefault,
  NumberParam,
} from 'use-query-params';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../../commons/Auth';
import { useAlert } from 'react-alert';
import { useLoading } from '../../commons/Loading';
import ContractsPresentational from './ContractsPresentational';
import contractsAPIs from '../../lib/fetch/contractsAPIs';
const { REACT_APP_DEFAULT_PAGINATION_LIMIT = 50 } = process.env;

const ContractsResume = ({ profile }) => {
  const [contracts, setContracts] = useState([]);
  const [total, setTotal] = useState(0);
  const [{ newToken, newIsAdmin } = {}] = useAuth();
  const [t] = useTranslation();
  const { showLoading, hideLoading } = useLoading();
  const alert = useAlert();

  const [query, setQuery] = useQueryParams({
    limit: withDefault(NumberParam, +REACT_APP_DEFAULT_PAGINATION_LIMIT),
    offset: NumberParam,
    year: NumberParam,
    pod_pdr: withDefault(StringParam, ''),
    condo_admin_cf: withDefault(StringParam, ''),
    condo_vat_cf: withDefault(StringParam, ''),
    address: withDefault(StringParam, ''),
    customer: withDefault(StringParam, ''),
    toBill: withDefault(StringParam, ''),
    contractSigningYear: NumberParam,
    contractSigningMonth: NumberParam,
    contractType: withDefault(StringParam, ''),
    partnerEonType: withDefault(StringParam, ''),
  });

  const {
    year,
    limit,
    offset,
    admin,
    condo_vat_cf,
    condo_admin_cf,
    pod_pdr,
    customer,
    toBill,
    contractSigningYear,
    contractSigningMonth,
    contractType,
    partnerEonType,
  } = query;

  function onFilter(queryDiff) {
    if (
      (queryDiff.pod_pdr && queryDiff.pod_pdr !== pod_pdr) || // first search
      (pod_pdr && queryDiff.pod_pdr === '') ||
      (queryDiff.contractSigningYear &&
        queryDiff.contractSigningYear !== contractSigningYear) || // first search
      (contractSigningYear && queryDiff.contractSigningYear === '') || // search deleted
      (queryDiff.contractSigningMonth &&
        queryDiff.contractSigningMonth !== contractSigningMonth) || // first search
      (contractSigningMonth && queryDiff.contractSigningMonth === '') || // search deleted
      (queryDiff.customer && queryDiff.customer !== customer) || // first search
      (customer && queryDiff.customer === '') || // search deleted
      (queryDiff.condo_vat_cf && queryDiff.condo_vat_cf !== condo_vat_cf) || // first search
      (condo_vat_cf && queryDiff.condo_vat_cf === '') || // search deleted
      (queryDiff.toBill && queryDiff.toBill !== toBill) || // first search
      (toBill && queryDiff.toBill === '') || // search deleted
      (queryDiff.contractType && queryDiff.contractType !== contractType) || // first search
      (contractType && queryDiff.contractType === '') || // search deleted
      (queryDiff.partnerEonType && queryDiff.partnerEonType !== partnerEonType) || // first search
      (partnerEonType && queryDiff.partnerEonType === '') || // search deleted
      (queryDiff.condo_admin_cf &&
        queryDiff.condo_admin_cf !== condo_admin_cf) || // first search
      (condo_admin_cf && queryDiff.condo_admin_cf === '') || // search deleted
      (queryDiff.limit && queryDiff.limit !== limit)
    ) {
      queryDiff.offset = 0; // return to first page
    }

    setQuery(queryDiff);
  }

  const fetchContracts = async (query) => {
    try {
      showLoading();
      const { data, total: _total } = await contractsAPIs.findResume({
        newToken,
        query,
      });
      setTotal(Number(_total || 0));
      setContracts(data.contracts);
      hideLoading();
    } catch (error) {
      hideLoading();
      alert.error(t('COMMON:GENERIC_ERROR'));
    }
  };

  useEffect(() => {
    fetchContracts({
      year,
      pod_pdr,
      condo_vat_cf,
      condo_admin_cf,
      offset,
      limit,
      customer,
      toBill,
      contractSigningYear,
      contractSigningMonth,
      contractType,
      partnerEonType,
    });
  }, [
    year,
    condo_vat_cf,
    pod_pdr,
    condo_admin_cf,
    offset,
    limit,
    customer,
    toBill,
    contractSigningYear,
    contractSigningMonth,
    contractType,
    partnerEonType,
  ]);

  return (
    <ContractsPresentational
      data={contracts}
      profile={profile}
      query={query}
      total={total}
      onFilter={onFilter}
    />
  );
};

export default ContractsResume;
